export const getNewsAPI = "/news";
export function getNewsDetailsAPI(id) {
  return "/news/" + id;
}
